<template>
  <div class="main" v-if="!showPrint">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">培训名称：</span>
        <el-input v-model="search.secureName" clearable placeholder="请输入培训名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">培训日期：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="secureName" label="培训名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dictName" label="培训类型" align="center"></el-table-column>
        <el-table-column prop="secureTime" label="培训日期" align="center"></el-table-column>
        <el-table-column prop="totals" label="培训对象" align="center"></el-table-column>
        <!-- <el-table-column prop="completes" label="已培训" align="center"></el-table-column> -->
        <el-table-column label="操作" align="center" width="280">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('preview')" @click="seeInfo(row)">查看</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('print')" @click="showPrints(row)">记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle === true ? '新增培训' :asyncTitle === false ?'修改':'查看详情'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="培训名称：" prop="secureName">
          <el-input v-model="ruleForm.secureName" clearable placeholder="请输入培训名称" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="培训类型：" prop="secureType">
          <el-select v-model="ruleForm.secureType" placeholder="请选择培训类型" clearable :disabled="disabled">
            <el-option
                v-for="item in optionsEnact"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="培训日期：" prop="secureTime">
            <el-date-picker
                v-model="ruleForm.secureTime"
                :disabled="disabled"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择培训日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="培训内容：" prop="files" >
            <upload-file :file-list.sync="ruleForm.files" :disabled="disabled">
                <template #info>
                    <span>点击上传文件，支持xls、xlsx、ppt、doc、docx、pdf格式</span>
                </template>
          </upload-file>
        </el-form-item>
        <el-form-item label="培训岗位：" prop="groupIds" v-if="asyncTitle === false">
          <el-select v-model="ruleForm.groupIds" placeholder="请选择培训岗位" clearable :disabled="disabled" multiple>
            <el-option
                v-for="item in optionsUsers"
                :key="item.posId"
                :label="item.posName"
                :value="item.posId">
            </el-option>
        </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="asyncTitle===true||asyncTitle===false">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else>
    <train-record :show-print.sync="showPrint" :rowsData.sync="rowsData"></train-record>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize} from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
import TrainRecord from './components/TrainRecord.vue'
import UploadFile from '../../components/uploadFile';
  export default {
    components:{
        TrainRecord,
        UploadFile
    },
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        disabled:false,//是否禁用
        loading: false,
        showPrint:false,//是否展示打印页面
        rowsData:null,//一行数据
        dataList: [], //安全培训信息
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        optionsEnact:[],//培训类型
        optionsUsers:[],//培训对象
        ruleForm: {
        }, // 按钮表单
        rules: {
          secureName: [{
            required: true,
            message: '请输入培训名称',
            trigger: 'blur'
          }],
          secureType: [{
            required: true,
            message: '请选择培训类型',
            trigger: 'change'
          }],
          secureTime: [{
            required: true,
            message: '请选择培训日期',
            trigger: 'change'
          }],
          files: [{
            required: true,
            message: '请选择上传文件',
            trigger: ['blur','change']
          }],
        },
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }else{
            this.$set(this.ruleForm, 'files', []);
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()
      that.getAllGroups()
    },
    methods: {
    //获得班组
    getAllGroups(){
        this.$api.Personnerl.GETSTATIONDATA({}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsUsers=res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //获取尺寸配筋转向等信息
    getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
            dictType:'train_type'
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsEnact = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
      //跳转记录界面
      showPrints(row){
        this.rowsData = row
        this.showPrint = true
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        params.strTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Safety.searchEnactLists(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
            this.loading = false;
          }else{
            this.$message.warning(res.statusMsg)
          }
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.disabled = false
      },
      //查看按钮
      seeInfo(val){
        this.asyncTitle = '8';
        this.asyncVisible = true;
        this.disabled = true
        this.$api.Safety.detailsEnactInfo({secureId:val.secureId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                this.$set(this.ruleForm, 'files', res.data.securePathDtos.map((item, index) => {
                    const type = item.securePathVideo.split('.');
                    return {
                        id: index + 1,
                        type: type[type.length - 1],
                        name: item.securePathVideoName,
                        url: item.securePathVideo
                    }
                }))
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 修改按钮信息
      updateProp(val) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.disabled = false
        this.$api.Safety.detailsEnactInfo({secureId:val.secureId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                let groupsArr = []
                res.data.secureGroupDtos.forEach(item=>{
                    groupsArr.push(item.groupId)
                })
                this.$set(this.ruleForm,'groupIds',groupsArr)
                this.$set(this.ruleForm, 'files', res.data.securePathDtos.map((item, index) => {
                    const type = item.securePathVideo.split('.');
                    return {
                        id: index + 1,
                        type: type[type.length - 1],
                        name: item.securePathVideoName,
                        url: item.securePathVideo
                    }
                }))
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Safety.deleteEnactInfo({secureId: row.secureId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.files = params.files&&params.files.map(item => {
               return item.url
            });
            this.$api.Safety.insertEnactInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.files = params.files&&params.files.map(item => {
               return item.url
            });
            params.secureTime = this.ruleForm.secureTime+' 00:00:00'
            this.$api.Safety.updateEnactInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>